import React, { Component, Suspense } from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import Entrance from './pages/entrance';
import Error from './pages/error';
import loadingIcon from '@/assets/loading.svg';
// import Answer from './pages/answer';

import RedirectIndex from './components/RedirectWithQuery';
import BandWindowProps from './components/BandWindowProps';
// import Board from './pages/board';
import './App.scss';

const Answer = React.lazy(() =>
  import(/* webpackChunkName: "Answer" */ './pages/answer')
);

console.log(
  '测试。。。。',
  window.REQUEST_URL,
  window.ROUTER_BASE_NAME,
  process.env
);
class App extends Component {
  render() {
    return (
      <Suspense
        fallback={
          <div className="app-loading">
            <img className="loading-icon" src={loadingIcon} alt="" />
          </div>
        }
      >
        <BrowserRouter basename={window.ROUTER_BASE_NAME}>
          <BandWindowProps />
          <Switch>
            <Route path="/entrance" component={Entrance} />
            <Route path="/answer" component={Answer} />
            <Route path="/error" component={Error} />
            {/* <Route path="/board" component={Board} /> */}
            <Route component={RedirectIndex} />
          </Switch>
        </BrowserRouter>
      </Suspense>
    );
  }
}

// class App extends Component {
//   render() {
//     return (
//       <BrowserRouter basename={window.ROUTER_BASE_NAME}>
//         <BandWindowProps />
//         <Switch>
//           <Route path="/entrance" component={Entrance} />
//           <Route
//             path="/answer"
//             component={
//               <Suspense fallback="">
//                 <Answer />
//               </Suspense>
//             }
//           />
//           <Route path="/error" component={Error} />
//           {/* <Route path="/board" component={Board} /> */}
//           <Route component={RedirectIndex} />
//         </Switch>
//       </BrowserRouter>
//     );
//   }
// }

export default App;
